import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ReactComponent as RightArrowIcon } from 'icons/right-arrow.svg';

import s from './Breadcrumbs.module.css';

const Breadcrumbs = React.memo(({ className, items, withArrows }) => (
  <div className={cn(className, s.root)}>
    {items.map(({ label, icon, current, disabled, onSelect }, i) => (
      <div key={label} className={s.item}>
        {withArrows && i > 0 && (
          <span className={cn(s.arrow, { [s.disabled]: disabled })}>
            <RightArrowIcon />
          </span>
        )}
        <span
          className={cn(s.tag, { [s.current]: current, [s.disabled]: disabled })}
          onClick={e => !disabled && onSelect(e)}
        >
          {label}
        </span>
      </div>
    ))}
  </div>
));

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  withArrows: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      current: PropTypes.bool.isRequired,
      disabled: PropTypes.bool.isRequired,
      onSelect: PropTypes.func.isRequired,
    }),
  ),
};

export default Breadcrumbs;
